<template>
  <v-dialog max-width="600px" v-model="showDialog" @update:model-value="handleDialogClose"
            @keydown.esc="handleEscape">
<!--    <template v-slot:activator="{ props: activatorProps }">-->
<!--      <v-btn v-bind="activatorProps">-->
<!--        Add New Client-->
<!--      </v-btn>-->
      <template v-if="true">
        <div>
          <div v-if="showParams">
            <div>newClientLevel0={{newClientLevel0}}</div>
            <div>newClientLevel1={{newClientLevel1}}</div>
            <div>newClientLevel2={{newClientLevel2}}</div>
            <div>newClientLevel3={{newClientLevel3}}</div>
            <div>newClientName={{newClientName}}</div>
            <div>newClientShortName={{newClientShortName}}</div>
            <div>newClientTypeID={{newClientTypeID}}</div>
            <div>newClientLegalTypeID={{newClientLegalTypeID}}</div>
            <div>newClientBillingTypeID={{newClientBillingTypeID}}</div>
          </div>
        </div>
      </template>

    <v-card>
      <v-card-title>
        <h4>Add a New Client</h4>
      </v-card-title>

      <!-- EndUser restriction -->
      <v-card-text v-if="currentClientType === 'endUser'">
        <v-alert type="warning" variant="tonal" prominent class="mb-0">
          <v-alert-title>EndUser account</v-alert-title>
          EndUser cannot add other clients. Upgrade to UniLevel or MultiLevel to manage sub-clients!
        </v-alert>
        <v-row justify="center" class="mt-4">
          <v-btn @click="showDialog = false">Close</v-btn>
        </v-row>
      </v-card-text>


<!--      newClientLevel0-->
      <v-card-text v-if="currentClientType !== 'endUser' && newClientLevel0">
        <v-card-subtitle class="font-weight-bold">Select Parent Client</v-card-subtitle>
        <!-- uniLevel or unknown: parent is own client, show as read-only -->
        <v-text-field
            v-if="currentClientType !== 'multiLevel' && currentClientType !== 'admin'"
            :model-value="parentClientName"
            label="Parent client name"
            outlined
            dense
            readonly
            bg-color="grey-lighten-4"
        ></v-text-field>
        <!-- multiLevel/admin: can pick any subclient as parent -->
        <v-autocomplete
            v-else
            v-model="newClientParentId"
            label="Parent client name"
            :items="clientsListForSelect"
            :loading="loadingClients"
            dense
            outlined
            required
            clearable
            auto-select-first
            @focus="newClientParentId = null"
        ></v-autocomplete>

        <v-card-subtitle class="font-weight-bold mt-4">New Client Details</v-card-subtitle>
        <v-text-field
            v-model="newClientName"
            label="Client Name"
            :rules="inputRulesName"
            required
            outlined
            autocomplete="off"
        ></v-text-field>
        <v-text-field
            v-model="newClientShortName"
            label="Short Name"
            outlined
            autocomplete="off"
        ></v-text-field>

        <v-card-subtitle class="font-weight-bold">Client Classification</v-card-subtitle>

        <v-row>
          <v-col>
            <v-divider class="mt-2"></v-divider>
            <v-select name="Select Client Type"
                      v-model="newClientTypeID"
                      :items="allowedClientTypes"
                      item-value="id"
                      item-title="title"
                      label="Select Client Type"
                      outlined
                      dense
                      clearable
            >
            </v-select>

            <v-select  name="Select Billing Type"
                       v-model="newClientBillingTypeID"
                       :items="clientBillingTypes"
                       item-value="id"
                       item-title="title"
                       label="Select Billing Type"
                       outlined
                       dense
                       clearable
            >
            </v-select>

            <v-text-field  label="Max Credit" v-if="newClientBillingTypeID==2"
                           v-model="newClientMaxCredit"
                           type="number"
                           outlined
                           placeholder="Enter maximum credit"
            />

            <v-switch
                v-if="currentClientType === 'multiLevel' || currentClientType === 'admin'"
                v-model="newClientIsDistributor"
                label="Is Distributor?"
                color="primary"
                hint="Distributors receive payments and manage their own services"
                persistent-hint
                density="compact"
            ></v-switch>
          </v-col>
        </v-row>
        <v-row justify="space-around" class="my-4">
          <v-btn   @click="selectClientType(1)"> Individual</v-btn>
          <v-btn   @click="selectClientType(2)"> Company</v-btn>
        </v-row>
      </v-card-text>

      <!--      newClientLevel0-->

      <v-card-text v-if="newClientLevel1">
        <v-card-title  v-if="newClientLegalTypeID===1 && false" class="font-weight-bold">Personal Data</v-card-title>
        <v-card-title  v-if="newClientLegalTypeID===2" class="font-weight-bold">Company Data</v-card-title>

          <v-text-field  v-if="newClientLegalTypeID===1" v-model="newClientName" label="Name" :rules="inputRulesName" autocomplete="off"></v-text-field>

          <v-text-field v-if="newClientLegalTypeID===2" v-model="newClientName" label='Company name' :rules="inputRules" autocomplete="off"></v-text-field>

          <v-text-field name="Registration Code" v-if="newClientLegalTypeID===2"
                        label="Registration Number"
                        v-model="newClientRegistrationCode"
                        type="text"
                        outlined
                        placeholder="Enter Registration Code"
                        autocomplete="off"
          />

          <v-text-field label="Company CUI/ID" v-if="newClientLegalTypeID===2"
                        v-model="newClientCUI"
                        type="text"
                        outlined
                        placeholder="Company CUI"
                        autocomplete="off"
          />

          <v-text-field label="Company Bank" v-if="newClientLegalTypeID===2"
                        v-model="newClientBank"
                        type="text"
                        outlined
                        placeholder="Company Bank"
                        autocomplete="off"
          />

          <v-text-field label="Company IBAN" v-if="newClientLegalTypeID===2"
                        v-model="newClientIBAN"
                        type="text"
                        outlined
                        placeholder="Company IBAN"
                        autocomplete="off"
          />
        <v-text-field :label="newClientLegalTypeID===2?'Company Phone *':'Phone *'"
                      v-model="newClientPhone"
                      type="text"
                      outlined
                      placeholder="Enter Phone"
                      :rules="[v => !!v || 'Phone is required']"
                      required
                      autocomplete="off"
        />

        <v-text-field  :label="newClientLegalTypeID===2?'Company Email *':'Email *'"
                       v-model="newClientEmail"
                       type="email"
                       outlined
                       placeholder="Enter Email"
                       :rules="[v => !!v || 'Email is required', v => /.+@.+\..+/.test(v) || 'Invalid email']"
                       required
                       autocomplete="off"
        />

        <v-text-field  label="Admin Username *"
                       v-model="newClientAdminUsername"
                       type="text"
                       outlined
                       placeholder="Username for admin user"
                       :hint="usernameCheckMessage"
                       persistent-hint
                       :rules="[v => !!v || 'Username is required', v => (v && v.length >= 5) || 'Min 5 characters']"
                       :error-messages="usernameExists ? ['Username already exists'] : []"
                       :loading="checkingUsername"
                       :color="newClientAdminUsername && newClientAdminUsername.length >= 5 && !usernameExists && !checkingUsername ? 'success' : undefined"
                       required
                       autocomplete="off"
                       @update:model-value="debouncedCheckUsername"
        />

          <v-text-field v-if="newClientLegalTypeID===2"
                        label="Company Notifications email"
                        v-model="newClientNotificationEmail"
                        type="text"
                        outlined
                        placeholder="Notification Email"
                        autocomplete="off"
          />



          <v-spacer></v-spacer>
        <v-row justify="space-around" class="mt-3">
          <v-btn v-if="newClientLevel1" @click="goToNewClientLevel0">Back</v-btn>
          <v-btn v-if="newClientLevel1" @click="goToNewClientLevel2">Next</v-btn>
        </v-row>
      </v-card-text>

      <!--      newClientLevel2-->
      <v-card-text v-if="newClientLevel2">
        <v-label>New Client Step 2</v-label>
        <v-form class="px-3" ref="form">
          <v-text-field v-if="newClientLegalTypeID==2" v-model="newClientRepresentativeName" label="Name" :rules="inputRules" autocomplete="off"></v-text-field>


          <v-textarea
                        label="address"
                        v-model="newClientAddress"
                        type="text"
                        outlined
                        placeholder="Address"
          />

          <v-autocomplete
              v-model="newClientCity"
              :items="citiesList"
              item-value="id"
              item-text="city"
              label="Select City"
              outlined
              dense
              clearable
          >
          </v-autocomplete>

           <v-autocomplete
              v-model="newClientCounty"
              :items="countiesList"
              item-value="id"
              item-text="county"
              label="Select County"
              outlined
              dense
              clearable
          >
          </v-autocomplete>

          <v-autocomplete
              v-model="newClientCountry"
              :items="countriesList"
              item-value="id"
              item-text="country"
              label="Select Country"
              outlined
              dense
              clearable
          >
          </v-autocomplete>

          <v-btn v-if="newClientLevel1" @click="goToNewClientLevel2">Next</v-btn>

          <v-menu v-model="menu" :close-on-content-click="false">
            <v-text-field :rules="inputRules"
              :value="formattedDate" clearable label="Due date" prepend-icon="date_range">
            </v-text-field>
            <v-date-picker v-model="due" @change="menu = false"></v-date-picker>
          </v-menu>

          <v-spacer></v-spacer>
          <v-row justify="space-around" class="mt-3">
            <v-btn v-if="newClientLevel2" @click="goToNewClientLevel1">Back</v-btn>
            <v-btn v-if="newClientLevel2" @click="goToNewClientLevel3">Next</v-btn>
          </v-row>

        </v-form>
      </v-card-text>

      <!--      newClientLevel3-->
     <v-card-text v-if="newClientLevel3">
        <v-label>New Client Step 3</v-label>

          <v-row justify="space-around" class="mt-3">
            <v-btn v-if="newClientLevel3" @click="goToNewClientLevel2">Back</v-btn>
            <v-btn large color="primary" @click="addNewClientLocal" class="success " :loading="loading" :disabled="!canSubmit">Add New Client</v-btn>
          </v-row>

      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import format from 'date-fns/format'
// import db from '@/fb'

import {log} from "@/composables/useLog";
import {getClientsGeneralSettings} from "@/composables/useGetGeneralSettings";
import {getClientTree} from "@/composables/useGetClientsAPI";
import useAddNewClient from "@/composables/useAddNewClient";
import useGetLoggedIn from "@/composables/useGetLoggedIn"
export default {
  props:["dialog"],
  data() {
    return {
      showDialog:false,
      showParams:false,
      newClientParentId: null,
      loadingClients: false,
      subclientsList: [],
      ownClientName: '',
      user: null,
      newClientPhone:null,
      newClientRepresentativeName:null,
      newClientNotificationEmail:null,
      newClientRegistrationCode:null,
      newClientEmail:null,
      newClientAdminUsername:null,
      usernameExists: false,
      checkingUsername: false,
      usernameCheckTimer: null,
      newClientBank:null,
      newClientIBAN:null,
      newClientAddress:null,
      newClientCity:1,
      newClientCounty:42,
      newClientCountry:1,
      newClientLevel0:true,
      newClientLevel1:false,
      newClientLevel2:false,
      newClientLevel3:false,
      newClientName: null,
      newClientShortName: null,
      newClientTypeID: null,
      newClientBillingTypeID: 2,
      newClientLegalTypeID: 2,
      newClientMaxCredit:null,
      newClientCUI:null,
      newClientIsDistributor:false,
      content: '',
      selectedClientType:null,
      generalSettings:null,
      clientTypes:null,
      clientBillingTypes:null,
     legalTypes:null,
      statusTypes:null,
      citiesList:[],
      countiesList:[],
      countriesList:[],
      due: null,
      menu: false,

      inputRules: [
        v => !!v || 'This field is required',
        v => v.length >= 5 || 'Minimum length is 5 characters'
      ],
      inputRulesName: [
        v => !!v || 'This field is required',
        v => v.length >= 3 || 'Minimum length is 5 characters'
      ],
      loading: false,
    }
  },
  methods: {
    debouncedCheckUsername() {
      if (this.usernameCheckTimer) clearTimeout(this.usernameCheckTimer)
      this.usernameExists = false
      if (!this.newClientAdminUsername || this.newClientAdminUsername.length < 5) return
      this.usernameCheckTimer = setTimeout(() => this.checkUsernameAvailability(), 500)
    },
    async checkUsernameAvailability() {
      this.checkingUsername = true
      try {
        const headers = { Authorization: `Bearer ${this.token}`, 'Content-Type': 'application/json' }
        const BASE_URL = import.meta.env.VITE_BASE_URL
        const url = `${BASE_URL}/home/check_username_availability?username=` + encodeURIComponent(this.newClientAdminUsername)
        const response = await fetch(url, { headers })
        const data = await response.json()
        this.usernameExists = data.exists === true
      } catch (e) {
        console.error('Error checking username:', e)
      } finally {
        this.checkingUsername = false
      }
    },
    handleDialogClose(value) {
      // Emitted when dialog visibility changes
      log("am primit eveniment ca v-dialog s.a inchis")
      if (!value) {
        log("am primit eveniment ca v-dialog s.a inchis si no value")
        this.$emit('dialogClosedEvent');
      }
    },
    handleEscape() {
      log("am primit eveniment ca v-dialog a apasat escape")
      // Emitted specifically when Escape is pressed
      this.$emit('dialogEscapedEvent');
    },
    updateDate(){
      log("nimic")
    },
    selectClientType(clientType){
      this.newClientLegalTypeID=clientType
      this.newClientLevel0=false
      this.newClientLevel1=true
      this.newClientLevel2=false
      this.newClientLevel3=false
    },
    goToNewClientLevel0(){
      this.newClientLevel0=true
      this.newClientLevel1=false
      this.newClientLevel2=false
      this.newClientLevel3=false
    },
    goToNewClientLevel1(){
      this.newClientLevel0=false
      this.newClientLevel1=true
      this.newClientLevel2=false
      this.newClientLevel3=false
    },
    goToNewClientLevel2(){
      this.newClientLevel0=false
      this.newClientLevel1=false
      this.newClientLevel2=true
      this.newClientLevel3=false
    },

    goToNewClientLevel3(){
      this.newClientLevel0=false
      this.newClientLevel1=false
      this.newClientLevel2=false
      this.newClientLevel3=true
    },
    async fetchClientTree() {
      try {
        this.loadingClients = true;
        const response = await getClientTree(this.token, this.user.client_id);
        if (response.error) {
          log("Error fetching client tree:", response.error_title);
        } else {
          log("Fetched client tree");
          this.ownClientName = response.clients_list[0].name || '';
          this.subclientsList = response.clients_list[0].children || [];
        }
      } catch (err) {
        console.error("Error fetching client tree:", err);
      } finally {
        this.loadingClients = false;
      }
    },
    addNewClientLocal() {
      log("calling addNewClient")
        this.loading = true
        const form = {
          newClientParentId:this.newClientParentId,
          newClientPhone:this.newClientPhone,
          newClientRepresentativeName:this.newClientRepresentativeName,
          newClientNotificationEmail:this.newClientNotificationEmail,
          newClientEmail:this.newClientEmail,
          newClientAdminUsername:this.newClientAdminUsername,
          newClientAddress:this.newClientAddress,
          newClientCity:this.newClientCity,
          newClientCounty:this.newClientCounty,
          newClientCountry:this.newClientCountry,
          newClientLevel1:this.newClientLevel1,
          newClientLevel2:this.newClientLevel2,
          newClientLevel3:this.newClientLevel3,
          newClientName:this.newClientName,
          newClientShortName:this.newClientShortName,
          newClientTypeID:this.newClientTypeID,
          newClientBillingTypeID:this.newClientBillingTypeID,
          newClientLegalTypeID:this.newClientLegalTypeID,
          newClientMaxCredit:this.newClientMaxCredit,
          newClientCUI:this.newClientCUI,
          newClientRegistrationCode:this.newClientRegistrationCode,
          newClientBank:this.newClientBank,
          newClientIBAN:this.newClientIBAN,
          isDistributor:this.newClientIsDistributor,
        }
        log(form)
        const {addNewClient}=useAddNewClient()
         addNewClient(this.token,form).then((response)=>{
           if(response.error==true){
             alert(response.message)
           }else{
             alert(response.message)
             this.$emit("reloadClientsEvent");
             this.showDialog=false
           }
           this.loading=false
         })

    }
  },
  created() {
    const { getLoggedIn, user, loggedIn, token } = useGetLoggedIn();
    getLoggedIn().then(() => {
// Logs from the provided instructions
      log("dupa created in Dashboard avem:");
      log("autorizare in Dashboard after getLoggedIn");
      log("user:");
      log(user);
      log("loggedIn: " + loggedIn.value);
      log("token: " + token.value);
      this.clientID=user.client_id
      this.user = user.value;
      this.token = this.$store.getters.getToken; // Setting token from store
      // Set default parent client to own client
      this.newClientParentId = user.value.client_id;
      // Fetch client tree for parent selection
      this.fetchClientTree();
        getClientsGeneralSettings().then((response) => {
          log(response)
          this.clientTypes = response.client_types
          this.clientBillingTypes = response.client_billing_types
          this.statusTypes = response.status_types
          this.legalTypes = response.legal_types
          this.citiesList = response.cities_list
          this.countiesList = response.counties_list
          this.countriesList = response.countries_list
          // Auto-select first allowed client type
          if (this.allowedClientTypes.length > 0 && !this.newClientTypeID) {
            this.newClientTypeID = this.allowedClientTypes[0].id
          }
          this.showDialog=true
        })

    });

  },
  computed: {
    formattedDate () {
      console.log(this.due)
      return this.due ? format(this.due, 'Do MMM YYYY') : ''
    },
    clientsList() {
      const list = [];
      // Add own client first
      if (this.user && this.user.userClient) {
        list.push({
          id: this.user.userClient.id,
          name: this.user.userClient.name,
          displayName: this.user.userClient.name,
          isOwn: true
        });
      }
      // Recursively add all subclients (all levels)
      const addSubclientsRecursively = (clients, level = 1) => {
        if (!clients || clients.length === 0) return;
        clients.forEach(subclient => {
          const indent = '—'.repeat(level) + ' ';
          list.push({
            id: subclient.client_id || subclient.id,
            name: subclient.name,
            displayName: indent + subclient.name,
            isOwn: false,
            level: level
          });
          // Recursively add children
          if (subclient.children && subclient.children.length > 0) {
            addSubclientsRecursively(subclient.children, level + 1);
          }
        });
      };
      addSubclientsRecursively(this.subclientsList);
      return list;
    },
    clientsListForSelect() {
      // Return simple {value, title} format for Vuetify v-select
      return this.clientsList.map(item => ({
        value: item.id,
        title: item.displayName
      }));
    },
    parentClientName() {
      return this.ownClientName || this.user?.userClient?.name || this.user?.client_name || ''
    },
    currentClientType() {
      const ct = this.user?.userClient?.client_type_name || this.user?.client?.client_type_name || this.user?.client_type_name || null
      log('currentClientType:', ct, 'userClient:', JSON.stringify(this.user?.userClient))
      return ct
    },
    // Filter client types based on current client type
    allowedClientTypes() {
      if (!this.clientTypes) return []
      if (this.currentClientType === 'multiLevel' || this.currentClientType === 'admin') {
        return this.clientTypes // multiLevel and admin can add any type
      }
      if (this.currentClientType === 'uniLevel') {
        // uniLevel can only add endUser
        return this.clientTypes.filter(ct => {
          const typeName = (ct.title || '').toLowerCase()
          return typeName === 'enduser'
        })
      }
      // Default for unknown type: allow only endUser
      return this.clientTypes.filter(ct => {
        const typeName = (ct.title || '').toLowerCase()
        return typeName === 'enduser'
      })
    },
    selectedTypeName() {
      if (!this.clientTypes || !this.newClientTypeID) return null
      const ct = this.clientTypes.find(t => t.id === this.newClientTypeID)
      return ct ? (ct.title || '') : null
    },
    canSubmit() {
      if (this.currentClientType === 'endUser') return false
      if (this.usernameExists) return false
      return true
    },
    usernameCheckMessage() {
      if (this.checkingUsername) return 'Checking availability...'
      if (this.usernameExists) return 'Username already taken'
      if (this.newClientAdminUsername && this.newClientAdminUsername.length >= 5) return 'Username available'
      return 'Username for the default admin user of this client'
    }
  }
}
</script>
